<template>
  <div class="sub-form-repeater sub-columns">
    <BaseInput name="min number" :validate="minValidator" class="sub-col" v-model="form.min" label="Min number of instances"/>
    <BaseInput name="max number" :validate="maxValidator" class="sub-col" v-model="form.max" label="Max number of instances" hint="0 = unlimited number of instances"/>
    <BaseInput class="sub-w100" v-model="form.title" label="Single instance title" :hint='`"Slideshow" could have a "Slide" title.`'/>
    <BaseInput class="sub-w100" v-model="form.labelFieldKey" label="Key of title field" :hint='`Single repeater instance can be labelled by text from other field.`'/>
  </div>
</template>

<script>
  import subformMixin from '@/mixins/sub-form.mixin'

  export default {
    mixins: [ subformMixin ],
    data () {
      return {
        form: {
          min: 1,
          max: 10,
          title: '',
          labelFieldKey: ''
        }
      }
    },
    computed: {
      minValidator () {
        return `required|integer|min_value:0${this.form.max == 0 ? '' : '|max_value:' + this.form.max }`
      },
      maxValidator () {
        return `required|integer|min_value:0`
      }
    }
    // created () {
    //   this.$validator.extend('maxRange', {
    //     getMessage: field => `The ${field} field must be ${this.form.min} or more.`,
    //     validate: val => {
    //       return val == 0 || val >= this.form.min
    //     }
    //   })
    // },
  }
</script>

<style lang="scss">

  .sub-form-repeater {
  }
</style>


// WEBPACK FOOTER //
// src/components/forms/sub-forms/SubFormRepeater.vue